export default function initLoginRecaptcha() {
    const form = document.getElementById('login-form');
    if (!form || !form.hasAttribute('data-recaptcha-site-key')) {
        return;
    }
    const siteKey = form.dataset.recaptchaSiteKey;
    const button = document.getElementById('login-submit-btn');
    const response = document.getElementById('login-recaptcha-response');
    const error = document.getElementById('login-recaptcha-error');
    let recaptchaPromise;
    let cancelRecaptchaLoad;

    const loadRecaptcha = () => {
        if (recaptchaPromise) {
            return recaptchaPromise;
        }

        recaptchaPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            let finished = false;
            const failLoad = (loadError) => {
                if (finished) {
                    return;
                }
                finished = true;
                script.remove();
                recaptchaPromise = null;
                cancelRecaptchaLoad = null;
                reject(loadError);
            };
            cancelRecaptchaLoad = () => failLoad(new Error('reCAPTCHA loading timed out'));
            script.src = `${form.dataset.recaptchaApiUrl}?render=${encodeURIComponent(siteKey)}&hl=${encodeURIComponent(
                form.dataset.recaptchaLanguage
            )}`;
            script.async = true;
            script.onload = () => {
                if (finished) {
                    return;
                }
                try {
                    window.grecaptcha.ready(() => {
                        if (!finished) {
                            finished = true;
                            cancelRecaptchaLoad = null;
                            resolve(window.grecaptcha);
                        }
                    });
                } catch (loadError) {
                    failLoad(loadError);
                }
            };
            script.onerror = () => {
                failLoad(new Error('reCAPTCHA failed to load'));
            };
            document.head.appendChild(script);
        });

        return recaptchaPromise;
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (button.disabled) {
            return;
        }

        button.disabled = true;
        error.hidden = true;
        response.value = '';
        let settled = false;
        const timeout = setTimeout(fail, 15000);

        function fail() {
            if (settled) {
                return;
            }
            settled = true;
            clearTimeout(timeout);
            if (cancelRecaptchaLoad) {
                cancelRecaptchaLoad();
            }
            button.disabled = false;
            error.hidden = false;
        }

        loadRecaptcha()
            .then((recaptcha) => {
                if (!settled) {
                    return recaptcha.execute(siteKey, { action: 'signin' });
                }
            })
            .then((token) => {
                if (settled) {
                    return;
                }
                if (!token) {
                    fail();
                    return;
                }
                settled = true;
                clearTimeout(timeout);
                response.value = token;
                form.submit();
            })
            .catch(fail);
    });

    loadRecaptcha().catch(() => {
        error.hidden = false;
    });
}
